import {NavigationTabsModuleTabModel} from "../navigation-tabs-module.tab-model";
import type {BaseLinkModel} from "../../../../../infrastructure/models/link/base-link-model";
import type {CompetitorCompetitionsViewModel} from "../../../../../domain/common/competitor/models/competitor-competitions.view-model";
import {NEW_COMPETITOR_CONTAINER} from "../../../../../containers/competitor-container/competitor-container.consts";
import {ACTION_TYPES} from "../../../../../core/consts";
import {APP} from "../../../../../core/app/consts";
import {computed, override} from "mobx";
import {ANALYTICS} from "../../../../../third-party-services/analytics/analytics-consts";
import {CompetitorSquadPageLinkModel} from "../../../../../containers/competitor-container/pages/squad-page/models/competitor.squad-page.link-model";

export class CompetitorSquadPageTabModel extends NavigationTabsModuleTabModel {
  index: Number;
  name: String;
  entity: CompetitorCompetitionsViewModel;
  currentLinkModel: BaseLinkModel;

  constructor(
    index: Number,
    name: String,
    entity: CompetitorCompetitionsViewModel,
    currentLinkModel: BaseLinkModel
  ) {
    super(index, name)

    this.entity = entity;
    this.currentLinkModel = currentLinkModel;
  }

  @computed get linkModel(): CompetitorSquadPageLinkModel {
    const linkModel: CompetitorSquadPageLinkModel = new CompetitorSquadPageLinkModel(this.entity.id, this.entity.sport.nameForURL, this.entity.nameForURL, this.entity.isFollow);

    return linkModel;
  }

  @override get isVisible(): Boolean {
    return this.entity.hasSquad;
  }

  get isActive(): Boolean {
    return this.currentLinkModel.params.page === NEW_COMPETITOR_CONTAINER.FILTERS.squad
  }

  get eventName(): String {
    return ACTION_TYPES.squadClick;
  }

  get eventParams(): Object {
    const eventParams = {
      entityType: APP.ANALYTICS.ENTITY_DISPLAY_TYPES[this.entity.objectType],
      entityId: this.entity.id,
      sportTypeId: this.entity.sport.id,
    }

    return eventParams;
  }

  get analyticsName(): Object {
    return ANALYTICS.TAB_NAMES.squad;
  }

  get analyticsEntityType(): Object {
    return ANALYTICS.ENTITY_TYPES.competitor;
  }

  get elementId(): String {
    return 'navigation-tabs_competitor_squad';
  }
}
